import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import './Component_TagGroup.scss';
import { ModuleFE_Tag } from '../_entity/tag/index.js';
export class Component_TagGroup extends ComponentSync {
    renderChildTag = (childTagId) => {
        const tagGroupChild = ModuleFE_Tag.cache.unique(childTagId);
        if (!tagGroupChild)
            throw new MUSTNeverHappenException(`cannot find tag group with id ${childTagId}`);
        return _jsx("div", { className: 'tag-group__items__item', children: tagGroupChild.label }, tagGroupChild._id);
    };
    render() {
        const tagGroup = this.props.tagGroup;
        const tagGroupParent = ModuleFE_Tag.cache.unique(tagGroup.key);
        if (!tagGroupParent)
            throw new MUSTNeverHappenException(`cannot find tag group with id ${tagGroup.key}`);
        return _jsxs(LL_V_L, { className: 'tag-group', children: [_jsx("div", { className: 'tag-group__label', children: tagGroupParent.label }), _jsx(LL_V_L, { className: 'tag-group__items', children: tagGroup.value.map(childTagId => {
                        return this.renderChildTag(childTagId);
                    }) })] });
    }
}
;
//# sourceMappingURL=Component_TagGroup.js.map